module.exports = __webpack_public_path__ + "static/favicon-409f5353e18ea4984750b3d882842a25.ico";